import store from 'store'
import Cookies from 'js-cookie'

import bdReq from './bdReq'

const STORE_KEYS = {
  user: 'auth__user',
  token: 'auth__token',
  muteStatus: 'mute_Status',
  artworkInterval: 'artwork_Interval'
}

const topDomain = (function topDomain () {
  const match = location.hostname.match(/(\.\w+.\.\w+$|localhost)/)
  if (!match) {
    return null
  }
  return match[0]
})()

const bdAuth = {
  _userEndpoint: '/me',
  _appId: null,

  authenticate (username, password, facebookToken = null) {
    let authReqDetails = null
    let postData = null

    if (facebookToken === null) {
      postData = {
        grant_type: 'password',
        username,
        password
      }
    } else {
      postData = {
        grant_type: 'facebook',
        accessToken: facebookToken
      }
    }

    return bdReq
      .post('/oauth/token', postData)
      .then((details) => {
        this._storeToken(details.body)
        authReqDetails = details
        return this.storeUser()
      })
      .then(() => authReqDetails)
      .catch((err) => {
        this.clear()
        throw new Error(err)
      })
  },

  setAppId (appId) {
    this._appId = appId
  },

  getAppId () {
    return this._appId
  },

  isAuthenticated () {
    return this.getTokenHeader() !== null
  },

  getToken () {
    // Try localStorage first (works on file:// origins), fall back to cookies
    const stored = store.get(STORE_KEYS.token)
    if (stored) return stored
    return Cookies.get(STORE_KEYS.token) ? JSON.parse(Cookies.get(STORE_KEYS.token)) : null
  },

  getTokenHeader () {
    const token = this.getToken()
    const tokenSet = token && token.token_type ? `${token.token_type} ${token.access_token}` : null
    return tokenSet
  },

  checkToken () {
    const token = this.getToken()
    const timestamp = this._getCurrentTime()
    const tokenExpired = timestamp > token.expirationTime

    if (!tokenExpired) {
      return Promise.resolve()
    }

    return this._refreshAuth(token.refresh_token)
  },

  checkResponseValid ({ status }) {
    switch (status) {
    case 400: {
      // token expired
      const token = this.getToken()
      const timestamp = this._getCurrentTime()
      const tokenExpired = timestamp > token.expirationTime
      if (tokenExpired) {
        this.clear()
        location.reload()
      }
      return true
    }
    case 401:
      // rootDispatcher.dispatch('AUTH:UNAUTHORIZED', {status});
      return false
    case 403:
      // rootDispatcher.dispatch('AUTH:FORBIDDEN', {status});
      return false
    }
  },

  clear () {
    store.remove('api-url') // TODO remove this, only temp so no-one has this in their store anymore
    store.remove(STORE_KEYS.user)
    store.remove(STORE_KEYS.token)
    Cookies.remove(STORE_KEYS.token, { domain: topDomain })
  },

  getUser (includeAll = false) {
    const user = store.get(STORE_KEYS.user)
    if (typeof user !== 'object') {
      return null
    }
    return includeAll ? user : user.user
  },

  setUserEndpoint (endpoint) {
    this._userEndpoint = endpoint
  },

  getUserEndpoint () {
    return this._userEndpoint
  },

  storeUser () {
    return new Promise((resolve, reject) => {
      if (!this.isAuthenticated()) {
        // user not authenticated yet
        resolve({ success: false, body: { message: 'Not Authenticated' } })
        return
      }

      bdReq
        .get(this._userEndpoint)
        .then(({ success, body }) => {
          if (!success) {
            resolve({
              success,
              body
            })
          }

          store.set(STORE_KEYS.user, body)

          resolve({
            success,
            body
          })
        })
        .catch(reject)
    })
  },

  updateUser (user) {
    store.set(STORE_KEYS.user, user)
  },

  _storeToken (token) {
    if (!token || !token.token_type) {
      return
    }
    const newToken = token
    newToken.expirationTime = this._getTokenExpirationTime(newToken.expires_in)
    store.set(STORE_KEYS.token, newToken)
    Cookies.set(STORE_KEYS.token, JSON.stringify(newToken), {
      domain: topDomain,
      expires: 7
    })
  },

  _getCurrentTime () {
    // in seconds
    return Math.floor(Date.now() / 1000)
  },

  _getTokenExpirationTime (expiresIn) {
    return this._getCurrentTime() + expiresIn
  },

  _refreshAuth (refreshToken) {
    return bdReq
      .post(
        '/oauth/token',
        {
          grant_type: 'refresh_token',
          refresh_token: refreshToken
        },
        true
      )
      .then(({ body }) => this._storeToken(body))
      .catch((err) => {
        this.clear()
        throw new Error(err)
      })
  }
}

// for debug purposes
window.clearAuth = () => {
  bdAuth.clear()
}

export default bdAuth